import { useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';


export const useIsEnhanceLimit = () => {
  const [isFromEnhanceLimit, setIsFromEnhanceLimit] = useState(false)
  const [isEnhanceOrElevate, setIsEnhanceOrElevate] = useState(false)

  const checkIfIsFromEnhanceLimit = async () => {
    const isEnhanceLimit = await AsyncStorage.getItem("application_id") !== null && await AsyncStorage.getItem("isElevate") !== "true"
    const isEnhanceOrElevate = await AsyncStorage.getItem("application_id") !== null;
    setIsFromEnhanceLimit(isEnhanceLimit)
    setIsEnhanceOrElevate(isEnhanceOrElevate)
  }

  useEffect(() => {
    checkIfIsFromEnhanceLimit();
  }, []);

  return { isFromEnhanceLimit, isEnhanceOrElevate };
};